<template>
  <div class="relative form-comp">
    <select
      v-if="computedType === 'select'"
      v-model="computedValue"
      :name="name"
      :multiple="multiple"
      :style="style"
      :disabled="disabled"
      :id="id"
      :required="required"
      :class="inputElClass"
      class="input-form-select"
    >
      <option :class="darkMode ? 'bg-darkmode-hard' : 'bg-white'" :value="''" disabled selected><span style="dark:placeholder-gray-400"> {{ placeholder }}</span></option>
      <option :class="darkMode ? 'bg-darkmode-hard' : 'bg-white'" v-for="option in options" :key="option.id ?? option" :value="option.id ?? option" :selected="option.id === '6a23c1e2-74c8-4fa4-a775-25bf14178adb'">{{ option.label ?? option.name ?? option.building_name ??  option.room_name ??  option.description  ?? option.authority ?? option.employee_name ?? option.time ?? option.invoice_no +" - "+option.outstanding ?? option.description ?? option.year_description ??  option.id ??option }}</option>
    </select>

    <!-- <div v-else-if="computedType === 'select_search'" class="form-input-select relative">
      <input
        ref="searchInput"
        type="text"
        v-model="search"
        @focus="showDropdown = true"
        @input="handleInput"
        @blur="handleBlur"
        :placeholder="'Type at least 3 characters...'"
        :class="inputElClass"
        class="input-form"
      />
      <ul
        v-show="showDropdown && filteredOptions.length"
        class="absolute z-10 w-full border rounded bg-white dark:bg-gray-800 mt-1 max-h-48 overflow-auto"
      >
        <li v-if="search.length < 3" class="px-3 py-2 text-gray-400 italic select-none">
          Type at least 3 characters...
        </li>
        <li
          v-else
          v-for="option in filteredOptions"
          :key="option.id ?? option"
          @mousedown.prevent="selectOption(option)"
          class="px-3 py-2 hover:bg-gray-100 dark:hover:bg-darkmode-hard cursor-pointer"
        >
          {{ optionLabel(option) }}
        </li>
      </ul>
    </div> -->

    <textarea
      v-else-if="computedType === 'textarea'"
      v-model="computedValue"
      :class="inputElClass"
      :style="style"
      :disabled="disabled"
      :name="name"
      :id="id"
      :placeholder="placeholder"
      :required="required"
      class="input-form"
    />

    <input
      v-else-if="computedType === 'currency'"
      ref="inputRef"
      v-model="computedValue"
      @input="$emit('update:modelValue', $event.target.value)"
      :name="name"
      :prosem="prosem"
      :autocomplete="autocomplete"
      :required="required"
      :style="style"
      :disabled="disabled"
      :id="id"
      :step="step"
      :placeholder="placeholder"
      :readonly="readonly"
      type="text"
      :class="icon ? 'pl-10' : ''"
      class="input-form"
    >

    <label v-else-if="computedType === 'switch'" class="switch">
      <input type="checkbox" v-model="computedValue" name="name" :required="required" :id="id" :readonly="readonly" />
      <span class="slider"></span>
    </label>

    <input
      v-else
      ref="inputEl"
      :value="modelValue"
      :name="name"
      :prosem="prosem"
      :autocomplete="autocomplete"
      :required="required"
      :style="style"
      :disabled="disabled"
      :id="id"
      :min="min"
      :max="max"
      :step="step"
      :placeholder="placeholder"
      :readonly="readonly"
      :type="computedType"
      @input="$emit('update:modelValue', $event.target.value)"
      :class="icon ? 'pl-10' : ''"
      class="input-form"
    >

    <control-icon
      v-if="icon"
      :icon="icon"
      :h="controlIconH"
      class="input-icon"
    />
  </div>
</template>

<script>
/* eslint-disable */
import { computed, ref, onMounted, onBeforeUnmount, watch, watchEffect } from 'vue'
import { useStore } from 'vuex'
import { useCurrencyInput } from 'vue-currency-input'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

import ControlIcon from '@/components/ControlIcon'

export default {
  name: 'Control',
  components: {
    ControlIcon,
    vSelect
  },
  props: {
    style: String,
    name: String,
    id: String,
    required: Boolean,
    disabled: Boolean,
    multiple: Boolean,
    step: String,
    autocomplete: String,
    placeholder: String,
    readonly: String,
    icon: String,
    options: { type: Array, default: null },
    min: { type: Number, default: 0 },
    max: { type: Number, default: 999999999999999 },
    optionsCurrency: Object,
    type: {
      type: String,
      default: 'text'
    },
    modelValue: {
      type: [String, Number, Boolean, Array, Object],
      default: ''
    },
    prosem: {
      type: [Array, Object]
    },
    borderless: Boolean,
    transparent: Boolean,
    hasError: Boolean,
    hasSuccess: Boolean,
    ctrlKFocus: Boolean,
    height: {
      type: String,
      default: '' // contoh: 'h-32' atau 'h-40'
    },
  },
  emits: ['update:modelValue', 'right-icon-click', 'prosemData'],
  setup (props, { emit }) {
    const computedValue = computed({
      get: () => props.modelValue,
      set: value => {
        emit('update:modelValue', value)
      }
    })

    if (props.prosem !== undefined) {
      emit('prosemData', [props.prosem[1], props.prosem[0][0].substr(0, 4), getMonthFromString(props.prosem[0][2])])
    }

    function getMonthFromString (mon) {
      const d = Date.parse(mon + '1, 2012')
      if (!isNaN(d)) {
        return new Date(d).getMonth() + 1
      }
      return -1
    }

    const inputElClass = computed(() => {
      const base = [
        'focus:ring focus:outline-none ring-red-600 ring-offset-2',
        'dark:placeholder-gray-400',
        computedType.value === 'textarea'
        ? (props.height || 'h-24')
        : 'h-12',
        props.multiple ? 'h-24' : 'h-12',
        props.borderless ? 'border-0' : 'border',
        props.transparent ? 'bg-transparent' : 'bg-white dark:bg-gray-800',
        props.hasError ? 'border-red-500' : (props.hasSuccess ? 'border-green-500' : 'border-gray-500')
      ]

      if (props.icon) {
        base.push('pl-10')
      }

      return base
    })

    const computedType = computed(() =>
      // (props.options && (props.type == 'select_search')) ? 'select_search' : props.options ? 'select' : props.type
      props.options ? 'select' : props.type
    )

    const controlIconH = computed(() => props.type === 'textarea' ? 'h-full' : 'h-full')

    const store = useStore()

    const darkMode = computed(() => store.state.darkMode)

    const inputEl = ref(null)

    const { inputRef, setOptions } = useCurrencyInput(props.optionsCurrency)

    watch(
      () => props.optionsCurrency,
      (optionsCurrency) => {
        setOptions(optionsCurrency)
      }
    )


    const search = ref('')
    const showDropdown = ref(false)
    const searchInput = ref(null)

    const optionLabel = (option) =>
      option.label ?? option.name ?? option.building_name ?? option.room_name ?? option.description ??
      option.authority ?? option.employee_name ?? option.time ?? option.invoice_no + ' - ' + option.outstanding ??
      option.year_description ?? option.id ?? option

    // watch(() => props.modelValue, () => {
    //   const match = props.options?.find(opt => (opt?.id ?? opt) === props.modelValue)
    //   search.value = match ? optionLabel(match) : props.modelValue?.toString() ?? ''
    // }, { immediate: true })

    watch(
      () => props.modelValue,
      () => {
        const optionsArray = Array.isArray(props.options)
          ? props.options
          : props.options
            ? Object.entries(props.options).map(([id, label]) => ({ id, label }))
            : []

        const match = optionsArray.find(
          (opt) => (opt?.id ?? opt) === props.modelValue
        )

        search.value = match ? optionLabel(match) : props.modelValue?.toString() ?? ''
      },
      { immediate: true }
    )

    const filteredOptions = computed(() => {
      const s = search.value?.toLowerCase() ?? ''
      if (s.length < 3) return []
      return props.options?.filter(opt => optionLabel(opt)?.toLowerCase().includes(s)) ?? []
    })

    const handleInput = () => {
      showDropdown.value = true
    }

    const selectOption = (option) => {
      const val = option.id ?? option
      emit('update:modelValue', val)
      search.value = optionLabel(option)
      showDropdown.value = false
    }

    const handleBlur = () => {
      setTimeout(() => {
        const matched = props.options?.find(opt => optionLabel(opt)?.toLowerCase() === search.value.toLowerCase())
        if (matched) {
          emit('update:modelValue', matched.id ?? matched)
        } else {
          emit('update:modelValue', search.value) // custom input
        }
        showDropdown.value = false
      }, 100)
    }



    if (props.ctrlKFocus) {
      const fieldFocusHook = e => {
        if (e.ctrlKey && e.key === 'k') {
          e.preventDefault()
          inputEl.value.focus()
        } else if (e.key === 'Escape') {
          inputEl.value.blur()
        }
      }

      onMounted(() => {
        if (!store.state.isFieldFocusRegistered) {
          window.addEventListener('keydown', fieldFocusHook)

          store.commit('basic', {
            key: 'isFieldFocusRegistered',
            value: true
          })
        } else {
          console.error('Duplicate field focus event')
        }
      })

      onBeforeUnmount(() => {
        window.removeEventListener('keydown', fieldFocusHook)

        store.commit('basic', {
          key: 'isFieldFocusRegistered',
          value: false
        })
      })


      watchEffect(() => {
        if(!props.options) {
          console.log("cek list doang", props.options)
        }
      })
    }

    return {
      computedValue,
      getMonthFromString,
      inputElClass,
      computedType,
      controlIconH,
      inputEl,
      inputRef,
      darkMode,
      search,
      showDropdown,
      filteredOptions,
      handleInput,
      handleBlur,
      selectOption,
      optionLabel,
      searchInput,
    }
  }
}
</script>

<style lang="scss">
  $switch-width: 50px;
  $switch-height: 26px;
  $switch-padding: 3px;
  $switch-bg-off: #ccc;
  $switch-bg-on: #005eff;
  $switch-knob-size: $switch-height - ($switch-padding * 2);

  .switch {
    position: relative;
    display: inline-block;
    width: $switch-width;
    height: $switch-height;

    input {
      opacity: 0;
      width: 0;
      height: 0;
    }

    .slider {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: $switch-bg-off;
      border-radius: $switch-height;
      cursor: pointer;
      transition: background-color 0.3s;

      &::before {
        content: "";
        position: absolute;
        height: $switch-knob-size;
        width: $switch-knob-size;
        left: $switch-padding;
        bottom: $switch-padding;
        background-color: #fff;
        border-radius: 50%;
        transition: transform 0.3s;
      }
    }

    // Saat checkbox dicentang
    input:checked + .slider {
      background-color: $switch-bg-on;

      &::before {
        transform: translateX($switch-width - $switch-knob-size - ($switch-padding * 2));
      }
    }
  }
</style>
